import { useEffect, useState } from "react";
import { Box, Typography, Button } from "@mui/material";

const ProfessionalsCard = ({
  sliderIndex,
  imageSrc,
  title,
  onClickButton,
  initialWidth = 290,
  initialHeight = 370,
  hoverScale = 1.09,
  hovByDefault = false,
  baseUrl = "",
  active,
  handleSlideChange = () => {},
}) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (hovByDefault) setIsActive(true);
  }, [hovByDefault]);

  useEffect(() => {
    if (active) {
      setIsActive(active);
      handleSlideChange(sliderIndex);
    } else setIsActive(false);
  }, [active, sliderIndex, handleSlideChange]);

  return (
    <Box
      sx={{
        position: "relative",
        width: initialWidth,
        height: initialHeight,
        borderRadius: 3,
        overflow: "hidden",
        cursor: "pointer",
        boxShadow: isActive ? 5 : 3,
        // transition: "all 0.8s ease-in-out",
        // transform: isActive ? `scale(${hoverScale})` : "scale(1)",
      }}
    >
      {/* Background Image */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${imageSrc})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Dark Overlay Gradient */}
        <Box
          sx={{
            position: "absolute",
            top: "50%", // Start gradient from middle or adjust as needed
            left: 0,
            right: 0,
            bottom: 0,
            background:
              "linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%)",
          }}
        />
      </Box>

      {/* Content - Title and Button Container */}
      <Box
        sx={{
          position: "absolute",
          bottom: isActive ? 0 : -36,
          left: 0,
          right: 0,
          p: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          justifyContent: "flex-end",
          zIndex: 1,
          transition: "all 0.5s ease-in-out",
        }}
      >
        {/* Title (Builders) */}
        <Typography
          variant="h6"
          sx={{
            fontSize: "18px",
            width: "100%",
            color: "white",
            fontWeight: "bold",
            transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
            transform: isActive ? "translateY(-10px)" : "translateY(0)",
            opacity: isActive && !hovByDefault ? 1 : 0.8,
            textAlign: "center",
          }}
        >
          {title}
        </Typography>

        {/* View List Button */}
        <Box
          component={"a"}
          href={baseUrl + `?industry=${title?.toLowerCase()}`}
          target="_blank"
          rel="noreferrer"
          width="100%"
        >
          <Button
            variant="outlined"
            color="primary"
            onClick={onClickButton}
            sx={{
              width: "100%",
              borderRadius: 8,
              transition:
                "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
              opacity: isActive ? 1 : 0,
              transform: isActive ? "translateY(0)" : "translateY(20px)",
              pointerEvents: isActive ? "auto" : "none",
            }}
          >
            View List
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default ProfessionalsCard;
